import { useTheme } from '@emotion/react'
import { Box, Divider, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'


const BatchCard = ({ value, batch, title }) => {
    // console.log("myBatch", batch)
    const theme = useTheme()
    const color = batch?.courseIsActiveForUser ? "green" : "red";
    const BatchStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '31%',
        maxWidth: '31%',
        minHeight: '130px',
        background: theme.palette.primary.mainTheme,
        border: `6px solid ${color}`,
        borderRadius: '15px',
        boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.20)',
        transition: 'all 0.3s',
        translate: `${value}px`,
        padding: '0 5%'
        // translate: `20px`
    }
    return (
        <Box sx={{ ...BatchStyle }}>

            <Link to={`/dashboard/studentBatches/studentList/1/${batch?._id}`} target='_blank' style={{ textDecoration: 'none', cursor: 'pointer' }}>
                <img src={batch?.banner[0]?.fileLoc} style={{ borderRadius: '5px' }} /><Divider />
                <Typography color="white" style={{ fontSize: '10px' }} sx={{ textAlign: 'center', fontWeight: '700' }}>
                    {batch?.batch_name ? batch?.batch_name : title} <br />
                    {batch?.batchId ? batch?.batchId : "NA"}
                </Typography>
            </Link>

        </Box>
    )
}

export default BatchCard